'use strict';

// MKTG-375 — reads Contentful content from local JSON snapshots instead of
// hitting cdn.contentful.com at runtime. Snapshots are generated offline by
// scripts/snapshot-contentful.js and committed to app/content/snapshots/.
//
// This is a drop-in wrapper: it returns a jQuery Deferred that resolves with
// { items: [...] } matching the shape produced by ContentfulParser.parseToFlatten,
// so existing callbacks in the codebase don't need to change their expectations.

var ContentSnapshots = function () {
  var cache = {};

  // Returns a Deferred that resolves with ONE argument (the parsed JSON data).
  // This matters because $.getJSON's jqXHR resolves with three args
  // (data, textStatus, jqXHR), and jQuery's $.when() wraps multi-value
  // resolutions into arrays when combined with other Deferreds. Normalizing
  // here keeps downstream callbacks (incl. $.when chains like TestimonialCarousel)
  // from getting [data, textStatus, jqXHR] instead of data.
  //
  // Also: on failure, clear the cache entry so a subsequent call can retry
  // instead of reusing the rejected promise forever.
  function load(name) {
    if (!cache[name]) {
      var dfd = $.Deferred();
      cache[name] = dfd.promise();
      $.getJSON('/content/snapshots/' + name + '.json').done(function (data) {
        dfd.resolve(data);
      }).fail(function (xhr) {
        delete cache[name];
        dfd.reject(xhr);
      });
    }
    return cache[name];
  }

  // Returns a Deferred that resolves to { items: [<one item matching predicate>] },
  // mirroring the single-entry response shape of ENTRIES_FROM_MODEL_BY_NAME / ENTRY.
  function findOne(name, predicate) {
    var dfd = $.Deferred();
    load(name).done(function (data) {
      var items = data && data.items || [];
      var match = null;
      for (var i = 0; i < items.length; i++) {
        if (predicate(items[i])) {
          match = items[i];break;
        }
      }
      dfd.resolve({ items: match ? [match] : [] });
    }).fail(function (xhr) {
      dfd.reject(xhr);
    });
    return dfd;
  }

  return { load: load, findOne: findOne };
}();